import { render, staticRenderFns } from "./deletion.vue?vue&type=template&id=78cf9128&"
import script from "./deletion.vue?vue&type=script&lang=js&"
export * from "./deletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports